module.exports = __webpack_public_path__ + "img/icon_about_10.72da8ca4.png";